<p
  class="tui-text_body-m-2 text-center"
  [innerHTML]="'Auth.Forgot Password.thanksDescription' | translate"
></p>
